import { render, staticRenderFns } from "./FormNewsCard.vue?vue&type=template&id=58964741&scoped=true"
import script from "./FormNewsCard.vue?vue&type=script&lang=js"
export * from "./FormNewsCard.vue?vue&type=script&lang=js"
import style0 from "./FormNewsCard.vue?vue&type=style&index=0&id=58964741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58964741",
  null
  
)

export default component.exports